<template>
  <div id="landing-page" class="ui container">
    <div id="hero" class="ui two column stackable grid">
      <div class="column center aligned middle aligned">
        <h2 class="ui header">
          红豆云 网盘
        </h2>
        <p class="text-xl my-6">
        在这里，你的数据真正只属于你自己
        <br />
        安全、好用，值得信赖
        </p>
        <p class="text-xl my-6">
        数据100%在客户端加密后再同步
        <br />
        跟泄露说拜拜
        </p>
        <div class="mt-6">
          <div class="ui large blue button" @click="$router.push({ name: 'register'})">
            注册
          </div>
          <div class="ui large basic teal button" @click="$router.push({ name: 'login'})">
            登录
          </div>
        </div>
      </div>
      <div class="column">
        <img class="d-none d-md-block w-100" src="03.svg" alt=""/>
      </div>
    </div>
    <!-- end of hero -->
    <div id="icons" class="ui three column stackable grid text-center text-lg font-bold">
      <div class="column item">
        <img class="mb-8 mx-auto" src="../assets/landing-icon1.svg" alt=""/>
        <h3 class="ui header">更安全</h3>
      </div>
      <div class="column item">
        <img class="mb-8 mx-auto" src="../assets/landing-icon2.svg" alt=""/>
        <h3 class="ui header">更可靠</h3>
      </div>
      <div class="column item">
        <img class="mb-8 mx-auto" src="../assets/landing-icon3.svg" alt=""/>
        <h3 class="ui header">更好用</h3>
      </div>
    </div>

    <div v-for="(f, index) in features" :key="'feature-' + index" class="feature ui two column center aligned middle aligned stackable grid">
      <div class="column">
        <img class="w-100" :src="get_img_url(f.img)" alt=""/>
      </div>
      <div class="column">
        <h3 class="ui header">{{ f.title }}</h3>
        <div class="items text-lg">
          <div v-for="(l, lindex) in f.lines" :key="'line-' + lindex">
            <i class="ui green text check icon"></i>
            {{ l }}
          </div>
        </div>
      </div>
    </div>
    <div id="pricing" class="mx-auto w-5/6">
      <div id="pricing-header" class="text-center text-3xl font-bold">
        <h1>服务价格</h1>
      </div>
      <div class="ui three column stackable grid center aligned">
        <div class="column">
          <div class="shadow border rounded-lg border-green-500 p-4">
            <div class="my-8">
              <h3>入门版</h3>
              <span class="price"><s>9.9</s></span>
              <span> 元/月</span>
            </div>
            <div class="details text-lg">
              <div>1GB 存储空间</div>
              <div>1GB 月下载量</div>
              <div>无限上传</div>
            </div>
            <button class="ui green fluid button" @click="signup('basic')">限时免费</button>
          </div>
        </div>
        <div class="column">
          <div class="shadow-2xl border rounded-lg border-purple-500 p-4">
            <div class="my-8">
              <h3>标准版</h3>
              <span class="price">27.9</span><span> 元/月</span>
            </div>
            <div class="details text-lg">
              <div>10GB 存储空间</div>
              <div>10GB 月下载量</div>
              <div>无限上传</div>
            </div>
            <button class="ui purple fluid button" @click="signup('standard')">注册</button>
          </div>
        </div>
        <div class="column">
          <div class="shadow border rounded-lg border-yellow-500 p-4">
            <div class="my-8">
              <h3>专业版</h3>
              <span class="price">89.9</span><span> 元/月</span> </div>
            <div class="details text-lg">
              <div>50GB 存储空间</div>
              <div>50GB 月下载量</div>
              <div>无限上传</div>
            </div>
            <button class="ui yellow fluid button" @click="signup('pro')">注册</button>
          </div>
        </div>
      </div>
    </div>
    <!-- end of pricing -->
    <h1 id="faq" class="mb-8 text-3xl text-center font-bold">常见问题</h1>
    <div class="text-left mx-auto w-5/6">
      <div v-for="(f, i) in faqs" :key="'faq-' + i" class="mt-8 text-lg">
        <p class="font-bold mb-2">Q: {{ f.q }}</p>
        <p>{{ f.a }}</p>
      </div>
    </div>
    <!-- end of faq -->
    <div id="get-started" class="text-center">
      <h1 class="text-2xl mb-4">上面没有回答到你的问题?</h1>
      <p class="text-xl">没关系，我们愿意与你交流任何话题！请填写联系方式，我们会在24小时内与你联系。</p>
      <div class="my-4">
        <a class="ui large blue button" @click="contact_us" href="https://uki6nd.fanqier.cn/f/xi2auv7i" target="_blank">联系我们</a>
      </div>
    </div>
    <!-- end of get started -->
    <TheFooter />
  </div>
</template>

<script>
import TheFooter from '../components/footer.vue'

export default {
  name: 'LandingPage',
  components: {
    TheFooter,
  },
  data: function () {
    return {
      features: [
        {
          title: "保护用户的数据隐私和安全是红豆云的使命",
          img: "landing-feature1.png",
          lines: [
            "数据使用AES-256高强度算法加密上传",
            "密钥只在客户端保存",
            "从此无惧服务端数据窥探",
          ],
        },
        {
          title: "可以信赖的云服务",
          img: "landing-feature2.png",
          lines: [
            "多云服务",
            "自动保存文件历史版本",
            "多副本数据备份",
          ],
        },
        {
          title: "用户体验 No. 1",
          img: "landing-feature3.png",
          lines: [
            "永不限速",
            "面向5G时代的全新构建的服务",
            "网络加速技术带来更快的上传下载体验",
          ],
        },
      ],
      faqs: [
        {
          q: "红豆云网盘有什么与众不同之处？",
          a: "数据被“端到端”加密——由客户端完成高强度加密以后再传输，服务器没有解密密钥——从根本上保证隐私和机密不会因人为操作或黑客攻击服务器而泄漏。红豆云的数据传输全链路使用SSL加密协议，杜绝上传下载过程中盗取信息的可能。",
        },
        {
          q: "上传下载量有上限吗？",
          a: "不同套餐的资源数量不同，具体信息请关注页面上的内容。红豆云网盘不是一个海量资源共享平台，而是帮助用户管理数据资产的可靠存储工具。做一款值得信赖的产品是我们团队最大的目标。",
        },
        {
          q: "红豆云是否会有桌面客户端？",
          a: "支持文件自动同步的红豆云网盘桌面端还在开发中，未来会同步支持Windows，macOS和Linux。",
        },
        {
          q: "红豆云是否会有手机端App呢？",
          a: "手机端红豆云App会在不久后推出，请持续关注我们。页面底部有红豆云官方微信公众号二维码，我们会在官方频道第一时间推送产品动态。",
        },
      ],
    };
  },
  computed: {
  },
  methods: {
    signup(l) {
      this.$gtag.event('pricing-signup', {
        event_category: 'user-action',
        event_label: l,
      });
      this.show_success("感谢关注，注册功能即将开放！");
    },
    get_img_url(a) {
      return require('../assets/' + a)
    },
    contact_us() {
      this.$gtag.event('landing-contact-us', {
        event_category: 'user-action',
      });
    },
  },
  mounted() {
  },
}
</script>

<style scoped>
#hero, #icons, #pricing, .feature, #faq, #get-started {
  margin-top: 80px;
}
#pricing-header {
  margin-bottom: 40px;
}
#pricing h3 {
  font-size: 1.5rem;
  font-weight: bold;
  margin-bottom: 3rem;
}
#pricing .price {
  font-size: 3em;
}
#pricing .details {
  margin-bottom: 2rem;
}
#pricing .details div {
  margin-top: 0.5rem;
}
#footer-hr {
  margin-top: 200px;
}
#icons {
  margin-top: 200px;
  margin-bottom: 200px;
}
#icons img {
  height: 100px;
}
#icons .item {
  margin-top: 80px;
}
#icons h3 {
  margin-bottom: 25px;
}
.feature h2 {
  margin-bottom: 60px;
}
.feature .items div {
  margin-bottom: 10px;
}
</style>
